"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "aci-sant-antonio": {
    "c0566b64": [{
      "hkey": "ca149ed6",
      "slug": "lavinaio-monterosso",
      "name": "Lavinaio-Monterosso",
      "primary": true,
      "skipSearch": false
    }],
    "lavinaio": [{
      "hkey": "ca149ed6",
      "slug": "lavinaio-monterosso",
      "name": "Lavinaio-Monterosso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c3e5210e": [{
      "hkey": "ca149ed6",
      "slug": "lavinaio-monterosso",
      "name": "Lavinaio-Monterosso",
      "primary": true,
      "skipSearch": false
    }],
    "monterosso-etneo": [{
      "hkey": "ca149ed6",
      "slug": "lavinaio-monterosso",
      "name": "Lavinaio-Monterosso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "aci-sant-antonio"
    }]
  }
};
exports["default"] = _default;